"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var cov_1exhuwbciy = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/withAuthentication.js";
  var hash = "61e3cf09b443291f4acbfbfe7a83649640f5ac50";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/withAuthentication.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "1": {
        start: {
          line: 17,
          column: 28
        },
        end: {
          line: 17,
          column: 52
        }
      },
      "2": {
        start: {
          line: 19,
          column: 33
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "3": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 21,
          column: 26
        }
      },
      "4": {
        start: {
          line: 20,
          column: 28
        },
        end: {
          line: 20,
          column: 52
        }
      },
      "5": {
        start: {
          line: 21,
          column: 11
        },
        end: {
          line: 21,
          column: 26
        }
      },
      "6": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 27
        }
      },
      "7": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "8": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 33,
          column: 8
        }
      },
      "9": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "10": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 65
        }
      },
      "11": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "12": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 68,
          column: 2
        }
      },
      "13": {
        start: {
          line: 70,
          column: 34
        },
        end: {
          line: 70,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "withAuthenticationComponent",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 36
          }
        },
        loc: {
          start: {
            line: 7,
            column: 48
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "AuthenticatedComponent",
        decl: {
          start: {
            line: 8,
            column: 18
          },
          end: {
            line: 8,
            column: 40
          }
        },
        loc: {
          start: {
            line: 16,
            column: 5
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 33
          },
          end: {
            line: 19,
            column: 34
          }
        },
        loc: {
          start: {
            line: 19,
            column: 44
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 26
          }
        }, {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 26
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 30
          }
        }, {
          start: {
            line: 25,
            column: 34
          },
          end: {
            line: 25,
            column: 40
          }
        }],
        line: 25
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 36
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "61e3cf09b443291f4acbfbfe7a83649640f5ac50"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAuthentication = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function withAuthenticationComponent(Component) {
  cov_1exhuwbciy.f[0]++;
  cov_1exhuwbciy.s[0]++;
  return function AuthenticatedComponent(_ref) {
    var authentication = _ref.authentication,
        onAuthentication = _ref.onAuthentication,
        _ref$authenticationCo = _ref.authenticationConfig,
        messages = _ref$authenticationCo.messages,
        config = _objectWithoutProperties(_ref$authenticationCo, ["messages"]),
        props = _objectWithoutProperties(_ref, ["authentication", "onAuthentication", "authenticationConfig"]);

    cov_1exhuwbciy.f[1]++;

    var _ref2 = (cov_1exhuwbciy.s[1]++, (0, _react.useState)(authentication)),
        _ref3 = _slicedToArray(_ref2, 2),
        auth = _ref3[0],
        setAuth = _ref3[1];

    cov_1exhuwbciy.s[2]++;

    var updateAuthentication = function updateAuthentication(_auth) {
      cov_1exhuwbciy.f[2]++;
      cov_1exhuwbciy.s[3]++;

      if (onAuthentication) {
        cov_1exhuwbciy.b[0][0]++;
        cov_1exhuwbciy.s[4]++;
        onAuthentication(_auth);
      } else {
        cov_1exhuwbciy.b[0][1]++;
        cov_1exhuwbciy.s[5]++;
        setAuth(_auth);
      }
    };

    var component = (cov_1exhuwbciy.s[6]++, _react.default.createElement("div", null));
    cov_1exhuwbciy.s[7]++;

    if ((cov_1exhuwbciy.b[2][0]++, !(0, _helpers.isAuthenticated)(auth)) && (cov_1exhuwbciy.b[2][1]++, config)) {
      cov_1exhuwbciy.b[1][0]++;
      cov_1exhuwbciy.s[8]++;
      component = _react.default.createElement(_.Authentication, {
        messages: messages,
        config: config,
        authentication: auth,
        onAuthentication: updateAuthentication
      });
    } else {
      cov_1exhuwbciy.b[1][1]++;
    }

    cov_1exhuwbciy.s[9]++;

    if ((0, _helpers.isAuthenticated)(auth)) {
      cov_1exhuwbciy.b[3][0]++;
      cov_1exhuwbciy.s[10]++;
      component = _react.default.createElement(Component, _extends({}, props, {
        authentication: auth
      }));
    } else {
      cov_1exhuwbciy.b[3][1]++;
    }

    cov_1exhuwbciy.s[11]++;
    return component;
  };
}

cov_1exhuwbciy.s[12]++;
withAuthenticationComponent.propTypes = {
  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Callback function to propogate the user/token used for API Authentication. */
  onAuthentication: _propTypes.default.func,

  /** Configuration to pass through to the Authentication component. */
  authenticationConfig: _propTypes.default.shape({
    /** Override the default text and errors. Must override all or none. */
    messages: _propTypes.default.shape({
      actionText: _propTypes.default.string.isRequired,
      genericError: _propTypes.default.string.isRequired,
      usernameError: _propTypes.default.string.isRequired,
      passwordError: _propTypes.default.string.isRequired
    }),

    /** The Gitea server to use when authenticating. */
    server: _propTypes.default.string.isRequired,

    /** The id of the token to create/retrieve that is used for the app. */
    tokenid: _propTypes.default.string.isRequired
  }).isRequired
};
var withAuthentication = (cov_1exhuwbciy.s[13]++, withAuthenticationComponent);
exports.withAuthentication = withAuthentication;